import CalculatorIcon from 'vectors/icons/calculator.svg';
import ChatIcon from 'vectors/icons/chat.svg';
import LightningIcon from 'vectors/icons/smallLightning.svg';

export const usps = [
  {
    icon: CalculatorIcon,
    title: 'Eerst berekenen en dan beslissen',
    text: 'De berekening van het totale kostenplaatje helpt jou de beste beslissing te nemen.',
  },
  {
    icon: ChatIcon,
    title: 'Advies van ervaren experts',
    text: 'Eerlijk advies door ervaren experts die dagelijks werken met elektrische voertuigen.',
  },
  {
    icon: LightningIcon,
    title: 'Voordeel voor nu en voor later',
    text: 'Bespaar op de aanschaf en profiteer via partners van blijvende voordelen en subsidies.',
  },
];
